module.exports = __webpack_public_path__ + "img/Faux Wood.5f865a0b.jpg";